import React from "react";

import { Flex, Typography } from "components";

export type StepItemCardProps = {
  stepNumber: number;
  title: string;
  description: string;
  className?: string;
  dataTestId?: string;
};

export const StepItemCard: React.FC<StepItemCardProps> = ({ stepNumber, title, description }) => (
  <Flex vertical>
    <Flex align="center" gap={8} className="margin-bottom-0">
      <div className="step-item-circle-number">
        <Typography variant="paragraph-s">{stepNumber}</Typography>
      </div>
      <Typography variant="paragraph-m" bold className="margin-top-0 margin-bottom-0">
        {title}
      </Typography>
    </Flex>
    <Typography variant="paragraph-s" color="grey-600" className="margin-top-0 margin-bottom-0 padding-left-200">
      {description}
    </Typography>
  </Flex>
);

export default StepItemCard;
